// ========================================
// MOCK DATA - Will be replaced by backend API
// ========================================

export const personalInfo = {
  name: "Joo James Memoria",
  title: "Full Stack Web Developer",
  tagline: "Building fast, efficient web apps — from clean UIs to solid backends.",
  shortBio: "Versatile web developer with strong experience in building and maintaining full-stack applications using JavaScript, TailwindCSS, React.js, Vue.js, PHP, and Laravel. Skilled in crafting intuitive, visually appealing websites and integrating OpenAI APIs for smart, interactive features. Proficient in automating workflows with Make and n8n and optimizing custom in-house frameworks to meet client needs. Known for problem-solving, attention to detail, and delivering high-quality results.",
  email: "joojames.memoria@gmail.com",
  phone: "+63 912 345 6789",
  location: "Philippines",
  available: true,
  resumeUrl: "/Memoria Resume.pdf",
  profileImage: "/img/me.jpg",
  stats: [
    { label: "Projects Built", value: "12+" },
    { label: "Years Experience", value: "7+" },
    { label: "Industries", value: "5+" },
    { label: "AI Tools Built", value: "3+" }
  ]
};

export const projects = [
  // ── New Public Projects ──
  {
    id: 13,
    title: "Zambosur Knights",
    description: "Dynamic website for Zambosur Knights, showcasing their services and community engagement with modern design and interactive features.",
    image: "/img/works/zambosur-knights.png",
    tags: ["React", "TailwindCSS", "Node.js"],
    category: "Client Work",
    liveUrl: "https://zambosurknights.com/",
    githubUrl: "#",
    featured: true
  },
  {
    id: 14,
    title: "Best Trip Bids",
    description: "Travel bidding platform connecting travelers with competitive offers. Built with user-friendly interface and secure payment integration.",
    image: "/img/works/besttripbids.png",
    tags: ["Laravel", "Vue.js", "TailwindCSS", "MySQL"],
    category: "Client Work",
    liveUrl: "https://besttripbids.com/",
    githubUrl: "#",
    featured: false
  },
  // ── Client / Public Projects ──
  {
    id: 1,
    title: "The Banking Scene",
    description: "Financial media platform covering banking, fintech, and payments. Built a fast, content-rich editorial site with custom CMS integration and SEO-optimised architecture.",
    image: "/img/works/tbs.png",
    tags: ["CraftCMS", "PHP", "TailwindCSS", "MySQL"],
    category: "Client Work",
    liveUrl: "https://thebankingscene.com/",
    githubUrl: "#",
    featured: true
  },
  {
    id: 2,
    title: "Vanroey Garnalen",
    description: "E-commerce and brand website for a premium Belgian shrimp company. Custom product showcase, multilingual support, and optimised checkout experience.",
    image: "/img/works/vanroey.png",
    tags: ["Laravel", "Vue.js", "TailwindCSS", "MySQL"],
    category: "Client Work",
    liveUrl: "https://www.vanroey.com/",
    githubUrl: "#",
    featured: false
  },
  {
    id: 15,
    title: "Bus Quote Pro",
    description: "Professional bus quoting platform for streamlined transportation services. Features advanced quote generation, fleet management, and client portal.",
    image: "/img/works/busquotepro.png",
    tags: ["PHP", "Laravel", "TailwindCSS", "MySQL"],
    category: "Client Work",
    liveUrl: "https://busquotepro.com/",
    githubUrl: "#",
    featured: false
  },
  {
    id: 3,
    title: "Formlets",
    description: "A powerful online form builder SaaS platform with drag-and-drop editor, conditional logic, 40+ field types, and response management.",
    image: "/img/works/formlets.png",
    tags: ["PHP", "Vue.js", "TailwindCSS", "MySQL"],
    category: "SaaS",
    liveUrl: "https://formlets.com/",
    githubUrl: "#",
    featured: true
  },
  {
    id: 4,
    title: "Struso",
    description: "Work management software with real-time collaboration and process automation. Feature-rich project board, team task tracking, and budget management.",
    image: "/img/works/struso.png",
    tags: ["Laravel", "Livewire", "AlpineJS", "MySQL"],
    category: "SaaS",
    liveUrl: "https://struso.com/",
    githubUrl: "#",
    featured: false
  },
  {
    id: 5,
    title: "Zenith — Demo",
    description: "A modern agency / consultancy demo site showcasing clean layout, animated sections, and conversion-focused design built as a client template.",
    image: "/img/works/zenith.png",
    tags: ["Vue.js", "TailwindCSS", "AlpineJS"],
    category: "Demo",
    liveUrl: "https://zenith-sample.pages.dev/",
    githubUrl: "#",
    featured: false
  },

  // ── DG Ventures Limited — Professional / Internal ──
  {
    id: 6,
    title: "AI Sales Coach",
    description: "Internal AI-powered sales coaching tool for DG Ventures agents. Real-time call feedback, script suggestions, objection handling tips, and performance analytics powered by OpenAI.",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80",
    tags: ["Laravel", "Vue.js", "OpenAI", "Make.com"],
    category: "AI & Automation",
    liveUrl: "#",
    githubUrl: "#",
    featured: true
  },
  {
    id: 7,
    title: "Company Project Management App",
    description: "Internal project management platform with AI-powered task suggestions, smart deadline estimation, team workload balancing, and Claude AI assistant integration.",
    image: "/img/works/company-project-management-app.png",
    tags: ["Laravel", "Livewire", "Claude AI", "MySQL"],
    category: "Internal Tool",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  },
  {
    id: 8,
    title: "Client Roadmap Website",
    description: "Public-facing product roadmap portal for DG Ventures clients. Displays upcoming features, release timelines, and progress updates with role-based access control.",
    image: "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=800&q=80",
    tags: ["Laravel", "Vue.js", "TailwindCSS", "MySQL"],
    category: "Internal Tool",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  },
  {
    id: 9,
    title: "Quote Builder with Template Editor",
    description: "Admin-side quote generation system with a visual template editor. Drag-and-drop layout builder, dynamic pricing rules, and one-click PDF export.",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    tags: ["PHP", "Laravel", "AlpineJS", "TailwindCSS"],
    category: "Internal Tool",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  },
  {
    id: 10,
    title: "Make.com & n8n Automations",
    description: "Built end-to-end business automation workflows for DG Ventures — CRM syncing, lead routing, email sequences, Slack notifications, and data pipeline orchestration.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    tags: ["Make.com", "n8n", "REST APIs", "Webhooks"],
    category: "AI & Automation",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  },
  {
    id: 11,
    title: "Vapi AI Voice Agent",
    description: "Integrated Vapi AI voice agents for automated outbound and inbound sales calls. Custom call flows, real-time transcription, CRM logging, and follow-up triggers.",
    image: "https://images.unsplash.com/photo-1589254065878-42c9da997008?w=800&q=80",
    tags: ["Vapi AI", "n8n", "OpenAI", "Laravel"],
    category: "AI & Automation",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  },
  {
    id: 12,
    title: "Python Web Scrapers",
    description: "Developed targeted data extraction scripts using Python — choosing between Selenium for JS-heavy sites and direct HTTP requests for lighter endpoints. Used for competitive intelligence and lead enrichment.",
    image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=800&q=80",
    tags: ["Python", "Selenium", "BeautifulSoup", "REST APIs"],
    category: "Developer Tool",
    liveUrl: "#",
    githubUrl: "#",
    featured: false
  }
];

export const skills = [
  {
    category: "Frontend",
    items: [
      { name: "HTML5 / CSS3", level: 96 },
      { name: "Tailwind CSS", level: 94 },
      { name: "Vue.js", level: 88 },
      { name: "React.js", level: 85 },
      { name: "AlpineJS", level: 80 }
    ]
  },
  {
    category: "Backend & CMS",
    items: [
      { name: "PHP", level: 90 },
      { name: "Laravel", level: 88 },
      { name: "Livewire", level: 83 },
      { name: "MySQL", level: 86 },
      { name: "CraftCMS", level: 80 }
    ]
  },
  {
    category: "AI Integration",
    items: [
      { name: "OpenAI API", level: 85 },
      { name: "Claude AI", level: 82 },
      { name: "Prompt Engineering", level: 88 },
      { name: "Vapi AI Voice Agent", level: 78 }
    ]
  },
  {
    category: "Automation",
    items: [
      { name: "Make.com", level: 90 },
      { name: "n8n", level: 86 },
      { name: "API Integrations", level: 92 }
    ]
  }
];

export const techStack = [
  { name: "HTML5", icon: "FileCode2" },
  { name: "PHP", icon: "Server" },
  { name: "MySQL", icon: "Database" },
  { name: "Tailwind CSS", icon: "Wind" },
  { name: "Vue.js", icon: "Code2" },
  { name: "React.js", icon: "Atom" },
  { name: "AlpineJS", icon: "Zap" },
  { name: "Laravel", icon: "Flame" },
  { name: "Livewire", icon: "Activity" },
  { name: "CraftCMS", icon: "PenTool" },
  { name: "Make.com", icon: "Network" },
  { name: "n8n", icon: "GitMerge" },
  { name: "OpenAI", icon: "Sparkles" },
  { name: "Claude AI", icon: "Bot" }
];

export const socialLinks = [
  { label: "LinkedIn", url: "https://www.linkedin.com/in/joo-james-memoria-developer/", icon: "Linkedin" },
  { label: "Email", url: "mailto:joojames.memoria@gmail.com", icon: "Mail" }
];

export const navLinks = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" }
];
